import {effect, inject} from '@angular/core';
import {signalStore, withHooks} from '@ngrx/signals';
import {Events, withEventHandlers} from '@ngrx/signals/events';
import {AuthEvents, AuthStore, isAuthenticatedIdentity} from '@scalified-monorepo/ng-shared/auth';
import {CqrsEvent} from '@scalified-monorepo/shared';
import {filter, map} from 'rxjs';
import {SseService} from '../sse.service';
import {getSseEventData} from '../sse.utils';
import {CqrsEventFactory} from './sse-events';

export const SseStore = signalStore(
  {providedIn: 'root'},
  withEventHandlers((_, sseService = inject(SseService), events = inject(Events)) => ({
    receiveCqrsEvent$: sseService.events$.pipe(
      map(e => getSseEventData(e as MessageEvent) as CqrsEvent),
      filter(event => !!event),
      map(event => CqrsEventFactory(event.type)(event))
    ),
    sseUnauthorized$: sseService.unauthorizedError$.pipe(map(() => AuthEvents.UnauthorizedError())),
    reconnectOnTokenRefresh$: events.on(AuthEvents.TokenRefreshed).pipe(map(() => sseService.forceReconnect())),
  })),
  withHooks(_ => ({
    onInit() {
      const sseService = inject(SseService);
      const authStore = inject(AuthStore);
      effect(() => {
        const identity = authStore.identity();
        if (isAuthenticatedIdentity(identity)) {
          sseService.connect();
        } else {
          sseService.disconnect();
        }
      });
    },
  }))
);
